import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function MegaphoneIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g stroke="currentColor" strokeWidth="1.5">
        <path
          d="m15.086 16.027-4.67-3.527H3.334c-.92 0-1.666-.746-1.666-1.667V7.5c0-.92.746-1.667 1.666-1.667h7.084l4.669-3.856a1.667 1.667 0 0 1 2.5 1.425v11.2a1.667 1.667 0 0 1-2.5 1.425Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M4.167 12.5v2.917c0 .92.746 1.666 1.666 1.666h.417c.92 0 1.667-.746 1.667-1.666V12.5" />
      </g>
    </Icon>
  );
}
